module.exports = __webpack_public_path__ + "img/ARM_Logo_White.5755774e.svg";